import { MouseEvent, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  Box,
  Divider,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';

import { IcEmergency } from '@/assets/images';
import { NarrowButton } from '@/components';

import { CareLinkRequest } from './CareLinkRequest';
import { CareLinkMenuRoot, CareLinkRoot } from './styles';
import { ICareLinkRequest } from './types';

export const CareLink = () => {
  const [menuState, setMenuState] = useState<{ anchorEl: null | HTMLElement }>({
    anchorEl: null,
  });

  const [data] = useState<ICareLinkRequest[]>([
    {
      id: '100000000000000000000001',
      location: {
        name: 'Green Meadows Care Center',
        address: '1425 Maplewood Drive, Springfield, IL 62704',
      },
      incidentCode: '26-A-1 (Sick person - Non-priority complaint)',
      description:
        'Staff reports an 82-years old resident experiencing general weakness and dizziness with no immediate life-threathening symptoms.',
    },
    {
      id: '200000000000000000000002',
      location: {
        name: 'Green Meadows Care Center',
        address: '1425 Maplewood Drive, Springfield, IL 62704',
      },
      incidentCode: '26-A-1 (Sick person - Non-priority complaint)',
      description:
        'Staff reports an 82-years old resident experiencing general weakness and dizziness with no immediate life-threathening symptoms.',
    },
  ]);

  const openActionMenu = Boolean(menuState.anchorEl);
  const menuElRef = useRef<HTMLButtonElement>(null);

  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenMenu = (e: MouseEvent<HTMLButtonElement>) => {
    setMenuState({ anchorEl: e.currentTarget });
  };

  const handleCloseMenu = () => {
    setMenuState({ anchorEl: null });
  };

  const handleAcceptRequest = (id: string) => {
    handleCloseMenu();
    navigate(`${location.pathname}/${id}`);
  };

  return (
    <CareLinkRoot style={{ zIndex: '99' }}>
      <NarrowButton
        style={{ backgroundColor: theme.palette.error.main }}
        className="btn-circle"
        onClick={(e) => handleOpenMenu(e)}
        aria-controls={openActionMenu ? 'action-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openActionMenu ? 'true' : undefined}
        aria-label="CareLink"
        ref={menuElRef}
      >
        <Tooltip title="CareLink">
          <span className="flex items-center">
            <IcEmergency />
          </span>
        </Tooltip>
      </NarrowButton>

      <CareLinkMenuRoot
        id="action-menu"
        anchorEl={menuState.anchorEl}
        open={openActionMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Stack spacing={1}>
          <Typography fontSize={16} fontWeight={500} textAlign="center" pb={2}>
            CareLink Requests
          </Typography>
          <Divider />
          <Box
            sx={{
              backgroundColor: theme.palette.sideBar.contrastText,
              minWidth: 300,
              maxWidth: 480,
            }}
          >
            <Stack spacing={2}>
              {data.map((clRequest, idx) => (
                <CareLinkRequest
                  key={idx}
                  data={clRequest}
                  onAcceptRequest={handleAcceptRequest}
                />
              ))}
              {data.length === 0 && (
                <Typography padding={2} alignSelf="center">
                  No Requests
                </Typography>
              )}
            </Stack>
          </Box>
        </Stack>
      </CareLinkMenuRoot>
    </CareLinkRoot>
  );
};
